interface SelfScheduleSectionProps {
  selfScheduleUrl?: string
  onSelfScheduleLinkCopy?: (url: string) => void
  selfScheduleDisabledReasons?: string[]
}

export function SelfScheduleSection({
  selfScheduleUrl,
  onSelfScheduleLinkCopy,
  selfScheduleDisabledReasons = [],
}: SelfScheduleSectionProps) {
  const showSelfScheduleUrl = !!selfScheduleUrl
  const showDisabledReasons = selfScheduleDisabledReasons.length > 0
  const hasSelfScheduleSection = showSelfScheduleUrl || showDisabledReasons

  if (!hasSelfScheduleSection) {
    return null
  }

  return (
    <div className="mt-4 pt-4 border-t border-sand-dark">
      <p className="font-semibold text-charcoal-75 mb-2 text-sm">Self-schedule link</p>

      {showSelfScheduleUrl && selfScheduleUrl && (
        <div className="flex items-center gap-2">
          <input
            type="text"
            value={selfScheduleUrl}
            readOnly
            className="flex-1 px-3 py-2 border border-gray-300 rounded text-sm bg-white"
            onClick={(e) => e.currentTarget.select()}
          />
          <button
            type="button"
            onClick={() => {
              navigator.clipboard.writeText(selfScheduleUrl)
              onSelfScheduleLinkCopy?.(selfScheduleUrl)
            }}
            className="px-3 py-2 bg-white border border-gray-300 rounded hover:bg-gray-50 text-sm font-medium"
          >
            Copy
          </button>
        </div>
      )}

      {showDisabledReasons && (
        <div className="p-4 rounded bg-gold-25 text-taupe-dark">
          <div className="flex gap-2">
            <i className="fa-solid fa-triangle-exclamation mt-0.5" aria-hidden="true" />
            <div>
              <p className="font-semibold text-sm">Self-scheduling unavailable</p>
              <ul className="mt-1 text-sm list-disc list-inside">
                {selfScheduleDisabledReasons.map((reason) => (
                  <li key={reason}>{reason}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
